/**
 * Check if the current page is in an iframe element
 * @return boolean true if in iframe, false otherwise
 */

export function isInIframe(): boolean {
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
}
